import getDecorators from 'inversify-inject-decorators';

import { rootContainer } from '../ioc';

import { SignatureStore } from './stores/signature.store';
import { SignModalStore } from './stores/sign-modal.store';

export const signatureContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(signatureContainer);

signatureContainer.bind(SignatureStore).toSelf().inSingletonScope();
signatureContainer.bind(SignModalStore).toSelf().inSingletonScope();
